import { ReactElement } from "react";

import {
  CampaignSortBy,
  CampaignStatus,
} from "~frontend/__generated__/graphql";
import { TableControls } from "~frontend/components/Table";
import {
  CAMPAIGN_SORTS,
  CAMPAIGN_STATUSES,
} from "~frontend/routes/subaccounts/campaignsList/constants";
import theme, { palette } from "~frontend/theme";

export default function FollowUpCampaignSelectorControls({
  statusFilter,
  setStatusFilter,
  search,
  setSearch,
  sort,
  setSort,
}: {
  statusFilter: string[];
  setStatusFilter: (newStatusFilter: CampaignStatus[]) => void;
  search: string;
  setSearch: (newSearch: string) => void;
  sort: string;
  setSort: (newSort: CampaignSortBy) => void;
}): ReactElement {
  return (
    <TableControls
      paperStyles={{
        backgroundColor: palette.lightGray,
        padding: theme.spacing(2),
      }}
      filters={[
        {
          id: "status",
          label: "Campaign Status",
          value: statusFilter,
          onChange: setStatusFilter as (newStatusFilter: string[]) => void,
          options: CAMPAIGN_STATUSES.map(status => ({
            value: status.value,
            label: status.label,
          })),
          multi: true,
        },
      ]}
      sort={{
        value: sort,
        onChange: setSort as (newSort: string) => void,
        options: CAMPAIGN_SORTS.map(sort => ({
          value: sort.value,
          label: sort.label,
        })),
      }}
      search={{
        value: search,
        onChange: setSearch,
        placeholder: "Search for a campaign...",
      }}
    />
  );
}
